import { BillBalanceModifierReference } from '../enums/BillBalanceModifierReference'

export const billBalanceModifierReferenceToTKey: Record<BillBalanceModifierReference, string> = {
  [BillBalanceModifierReference.BankPayment]: 'bills.view.payment_pane.modifier.bank_payment',
  [BillBalanceModifierReference.Bill]: 'bills.view.payment_pane.modifier.credit_note',
  [BillBalanceModifierReference.ContactBalancePayment]: 'bills.view.payment_pane.modifier.contact_balance_payment',
  [BillBalanceModifierReference.DaybookTransaction]: 'bills.view.payment_pane.modifier.daybook_transaction',
}
